module.exports = __webpack_public_path__ + "static/scale-model-of-cultural-encounters-inc-in-ann-arbor-michigan-ab131ca2bbad2d0c24e09306a9da4254.png";